module.exports = __webpack_public_path__ + "static/media/MK.1d7fe66d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MK.svg
// module id = 312
// module chunks = 0